export function isPhoneUserAgent(ua: string): boolean {
  if (!ua) return false
  if (/iPad|Tablet|Silk/i.test(ua)) return false
  if (/iPhone/i.test(ua)) return true
  if (/Android/i.test(ua) && /Mobile/i.test(ua) && !/Tablet/i.test(ua)) return true
  return false
}

export function isFaceIdUserAgent(ua: string): boolean {
  return /iPhone|iPad|iPod/i.test(ua)
}

export function isPortrait(): boolean {
  if (typeof window === 'undefined') return false
  try {
    if (window.matchMedia?.('(orientation: portrait)').matches) return true
    if (window.matchMedia?.('(orientation: landscape)').matches) return false
  } catch {
    /* ignore */
  }
  return window.innerHeight >= window.innerWidth
}
